import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { SearchChargeFilterSpec } from './service-common';
import type {
  BoardDTO,
  BoardScope,
  BoardType,
  CreateBoardRequest,
  UpdateBoardRequest,
  WrapperResponseBoardDTO,
  WrapperResponseChargeSummaryDTO,
  WrapperResponseListBoardDTO
} from '../core/models';

@Injectable({
  providedIn: 'root'
})
export class BoardService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/boards`;

  list(type: BoardType = 'COLLECTIONS'): Observable<WrapperResponseListBoardDTO> {
    const params = new HttpParams().set('type', type);
    return this.http.get<WrapperResponseListBoardDTO>(this.apiUrl, { params });
  }

  get(id: number): Observable<WrapperResponseBoardDTO> {
    return this.http.get<WrapperResponseBoardDTO>(`${this.apiUrl}/${id}`);
  }

  create(request: CreateBoardRequest): Observable<WrapperResponseBoardDTO> {
    return this.http.post<WrapperResponseBoardDTO>(this.apiUrl, request);
  }

  update(id: number, request: UpdateBoardRequest): Observable<WrapperResponseBoardDTO> {
    return this.http.put<WrapperResponseBoardDTO>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: number): Observable<WrapperResponseBoardDTO | { ok?: boolean }> {
    return this.http.delete<WrapperResponseBoardDTO | { ok?: boolean }>(`${this.apiUrl}/${id}`);
  }

  /**
   * Resumen agregado (cantidad de recibos) — GET /boards/charges/summary.
   */
  summarizeCharges(spec: SearchChargeFilterSpec = {}): Observable<WrapperResponseChargeSummaryDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== '') {
            params = params.append(key, String(v));
          }
        });
      } else if (value !== '') {
        params = params.append(key, String(value));
      }
    });
    return this.http.get<WrapperResponseChargeSummaryDTO>(`${this.apiUrl}/charges/summary`, { params });
  }
}

export type { BoardDTO, BoardScope, BoardType, CreateBoardRequest, UpdateBoardRequest };
